import { useState, type JSX } from "react";

import { CollapseTransition } from "../CollapsibleHeight";
import {
    Section,
    SectionBackgroundVariant,
    SectionContent,
    SectionLevel,
    SectionStyleVariant,
} from "../Section";

import { SectionHeaderWithCollapse } from "./SectionHeaderWithCollapse";

interface CollapseContentSectionProps {
    children: React.ReactNode;
    titleLabel: React.ReactNode;
    subtitleLabel?: React.ReactNode;
    styleVariant: SectionStyleVariant;
    backgroundVariant?: SectionBackgroundVariant;
    initialCollapsed?: boolean;
    collapsed?: boolean;
    /** Also stops the header from toggling. */
    hideCollapseButton?: boolean;
    level: SectionLevel;
    noPadding?: boolean;
    headerRightChildren?: JSX.Element;
    id?: string;
}
export function CollapseContentSection({
    children,
    titleLabel,
    subtitleLabel,
    styleVariant,
    backgroundVariant,
    level,
    headerRightChildren,
    noPadding = false,
    initialCollapsed = false,
    collapsed: controlledCollapsed,
    hideCollapseButton = false,
    id,
}: CollapseContentSectionProps): JSX.Element {
    const [ownCollapsed, setOwnCollapsed] = useState(() => initialCollapsed);
    const collapsed = controlledCollapsed ?? ownCollapsed;

    const handleCollapse = () => {
        setOwnCollapsed(!collapsed);
    };

    return (
        <Section id={id} styleVariant={styleVariant}>
            <SectionHeaderWithCollapse
                titleLabel={titleLabel}
                subtitleLabel={subtitleLabel}
                collapsed={collapsed}
                handleCollapse={handleCollapse}
                level={level}
                backgroundVariant={backgroundVariant}
                rightChildren={headerRightChildren}
                hideButton={hideCollapseButton}
            />
            <CollapseTransition collapsed={collapsed}>
                <SectionContent
                    noPadding={noPadding}
                    backgroundVariant={backgroundVariant}
                >
                    {children}
                </SectionContent>
            </CollapseTransition>
        </Section>
    );
}
